import { lazy } from "react";

const RELOADED_KEY = "lazyPageReloaded";

/**
 * React.lazy for a route page. A tab opened before a deploy can ask for a
 * chunk that deploy/deploy.sh has since pruned; rather than leave the page
 * blank, reload once so the tab picks up the current release. The session
 * flag stops a chunk that is really missing from reloading forever.
 */
export default function lazyPage(load) {
  return lazy(() =>
    load().then(
      (module) => {
        sessionStorage.removeItem(RELOADED_KEY);
        return module;
      },
      (error) => {
        if (!sessionStorage.getItem(RELOADED_KEY)) {
          sessionStorage.setItem(RELOADED_KEY, "1");
          window.location.reload();
          return new Promise(() => {});
        }
        throw error;
      },
    ),
  );
}
